import { useState } from 'react';
import { DetailsHistoryUseModal } from '../Modals/DetailsHistoryUseModal';
import MUIDataTable from 'mui-datatables';
import InfoImg from '../../assets/info.svg';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Container, IconButton } from './styles';
import { Button, Icon } from 'rbx';
import { useFetch } from '../../hooks/useFetch';
import { API_URL } from '../../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';

export function HistoryUse({ reload }) {
  const [viewAll, setViewAll] = useState(false)
  const [isDetailsHistoryUseModalOpen, setIsDetailsHistoryUseModalOpen] =
    useState(false);
  const [detailsData, setDetailsData] = useState({});

  const { response, load } = useFetch(`${API_URL}/historic-parkings?p=${reload}${viewAll ? '&all=true' : ''}`)

  const historyUseData = response?.data?.indexParking || []

  function handleOpenDetailsHistoryUseModal() {
    setIsDetailsHistoryUseModalOpen(true);
  }

  function handleCloseDetailsHistoryUseModal() {
    setIsDetailsHistoryUseModalOpen(false);
    setDetailsData({});
  }

  const theme = createMuiTheme({
    typography: {
      fontFamily: `"Poppins", "Roboto", "Arial", sans-serif`,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    // overrides: {
    //   MUIDataTableToolbar: { root: { display: 'none' } },
    // },
  });

  theme.shadows = [];

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'startDate',
      label: 'Data e hora',
      options: {
        filter: false,
        sort: false,
        display: true,
      },
    },
    {
      name: 'licensePlate',
      label: 'Placa',
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: 'authenticateCode',
      label: 'Código de autenticação',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'Detalhes',
      label: 'Detalhes',
      options: {
        filter: false,
        sort: false,
        display: true,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButton
              onClick={async () => {
                handleOpenDetailsHistoryUseModal()
                setDetailsData(historyUseData.find(
                  history => history.id === tableMeta.rowData[0]
                ))
              }}
            >
              <img src={InfoImg} alt="Mais informações" />
            </IconButton>
          );
        },
      },
    },
  ];

  const data = [];
  for (var i = 0; i < historyUseData.length; i++) {
    data.push({
      id: historyUseData[i].id,
      startDate: historyUseData[i].startDate,
      licensePlate: historyUseData[i].licensePlate,
      authenticateCode: historyUseData[i].authenticateCode,
    });
  }

  const options = {
    responsive: 'standard',
    draggableColumns: {
      enabled: false,
    },
    selectableRows: 'none',
    rowsPerPage: 2,
    rowsPerPageOptions: [],
    print: 'false',
    filter: 'false',
    download: 'false',
    viewColumns: 'false',
    onDownload: (buildHead, buildBody, columns, data) => {
      return '\uFEFF' + buildHead(columns) + buildBody(data);
    },
    textLabels: {
      body: {
        noMatch: 'Nenhum registro encontrado.',
        toolTip: 'Ordenar',
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: 'Próxima Página',
        previous: 'Página Anterior',
        rowsPerPage: 'Linhas por página:',
        displayRows: 'resultado(s) de', // 1-10 of 30
      },
      toolbar: {
        search: 'Pesquisar',
        viewColumns: 'Selecionar Colunas',
        filterTable: 'Filtrar Tabela',
      },
      filter: {
        title: 'FILTROS',
        reset: 'limpar',
        all: 'Todos',
      },
      viewColumns: {
        title: 'Mostrar Colunas',
        titleAria: 'Mostrar/Esconder Colunas da Tabela',
      },
    },
    customToolbarSelect: () => {},
    expandableRows: false,
    expandableRowsOnClick: false,
  };

  return (
    <Container>
      <DetailsHistoryUseModal
        isOpen={isDetailsHistoryUseModalOpen}
        onRequestClose={handleCloseDetailsHistoryUseModal}
        detailsData={detailsData}
      />

      <MuiThemeProvider theme={theme}>
        <p className='mt-1 is-flex is-align-items-center'>
          <span>
            {viewAll && !load ? '* Está sendo exibido o histórico completo' : '* Histórico dos últimos 90 dias'}
          </span>
          {
            load && (
              <Icon className='fa-spin'>
                <FontAwesomeIcon icon={faSyncAlt} />
              </Icon>
            )
          }
          {
            !viewAll && (
              <Button 
                type='button' 
                className='ml-2' 
                size='small' 
                color='primary'
                rounded
                onClick={() => setViewAll(true)}
              >
                Ver Tudo
              </Button>
            )
          }
        </p>
        <MUIDataTable
          title='Histórico de uso'
          data={data}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    </Container>
  );
}
